import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api, type ProjectListItem } from '../api';
import { useAuth } from '../auth';
import { Badge, Button, Card, EmptyState, Page, IconFolder, IconPlus, IconRocket } from '../ui';

export function ProjectsHome() {
  const { me } = useAuth();
  const nav = useNavigate();
  const [projects, setProjects] = useState<ProjectListItem[]>([]);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    api
      .listProjects()
      .then(({ projects }) => setProjects(projects))
      .catch(() => setErr('Falha ao carregar projetos'));
  }, []);

  if (err) return <Page title="Projetos"><div className="ui-error-banner">{err}</div></Page>;

  const isAdmin = me?.globalRole === 'admin';

  return (
    <Page
      title="Projetos"
      subtitle="Cada projeto começa pelo planejamento e cresce conforme a necessidade."
      actions={
        isAdmin ? (
          <Button variant="primary" leftIcon={<IconPlus size={14} />} onClick={() => nav('/neo')}>
            Novo projeto
          </Button>
        ) : null
      }
    >
      {projects.length === 0 ? (
        <EmptyState
          icon={<IconRocket size={28} />}
          title="Nenhum projeto ainda"
          description={
            isAdmin
              ? 'Crie um projeto e comece pelo planejamento — diagnóstico, posicionamento e mais.'
              : 'Aguarde um admin te dar acesso a um projeto.'
          }
          action={
            isAdmin ? (
              <Button variant="primary" leftIcon={<IconPlus size={14} />} onClick={() => nav('/neo')}>
                Criar projeto
              </Button>
            ) : null
          }
        />
      ) : (
        <div style={{ display: 'grid', gap: 'var(--space-3)', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))' }}>
          {projects.map((p) => (
            <Link key={p.id} to={`/p/${p.slug}`} style={{ textDecoration: 'none', color: 'inherit' }}>
              <Card hover>
                <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-3)' }}>
                  <div
                    style={{
                      width: 36, height: 36,
                      borderRadius: 'var(--radius-md)',
                      background: 'var(--color-accent-soft)',
                      color: 'var(--color-accent)',
                      display: 'grid', placeItems: 'center',
                    }}
                    aria-hidden
                  >
                    <IconFolder size={18} />
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 600, fontSize: 'var(--font-size-lg)' }}>{p.name}</div>
                  </div>
                  {p.role && <Badge variant="outline">{p.role}</Badge>}
                </div>
              </Card>
            </Link>
          ))}
        </div>
      )}
    </Page>
  );
}
